import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { userRole } from '../constants/data';
import { getUserData } from '../functions/services';

export const AuthAdmin = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                if (getUserData().user.rol === userRole.admin) {
                    return <Component {...props} />;
                } else {
                    return <Redirect to="/" />;
                }
            }}
        />
    );
};

export default AuthAdmin;
